import { Container } from "./styles";

const FieldInformation = ({
    field, value,
    marginTop
}) => {
    return (
        <Container marginTop={marginTop}>
            <h5>{field}</h5>            
            <span>{value}</span>
        </Container>
    );
}

export default FieldInformation;